import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { memo, useCallback, useState } from 'react';
import classNames from 'classnames/bind';
import { Button, Checkbox, Input, MailIcon, Modal, Text } from '@beef/ui-kit';
import { useOnScreenEffect } from '@beef/utils';
import { useSubscribeEmailTextAgreement } from "../../../../../hooks/useSubscribeEmailTextAgreement";
import { validateEmail } from "../../../../../utils/validators";
import { subscribeMailingList } from "../../../../../utils/emailAgreement";
import { sendYmOnSubscribeSuccess, sendYmOnSubscribeView } from "../../analytics/mailSubscribe";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var MailInput = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    texts = _ref.texts,
    isVertical = _ref.isVertical,
    subscribeEmailURL = _ref.subscribeEmailURL,
    subscribeEmailTextAgreementURL = _ref.subscribeEmailTextAgreementURL;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorText = _useState4[0],
    setErrorText = _useState4[1];
  var _useState5 = useState('initial'),
    _useState6 = _slicedToArray(_useState5, 2),
    requestStatus = _useState6[0],
    setRequestStatus = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    checked = _useState8[0],
    setChecked = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    modalIsOpen = _useState10[0],
    setModalIsOpen = _useState10[1];
  var consentText = useSubscribeEmailTextAgreement(subscribeEmailTextAgreementURL);
  var ref = useOnScreenEffect(function () {
    sendYmOnSubscribeView();
  }, []);
  var onSubmit = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            if (value.length) {
              _context.next = 4;
              break;
            }
            setErrorText(texts.errorMailEmpty);
            return _context.abrupt("return");
          case 4:
            if (validateEmail(value)) {
              _context.next = 7;
              break;
            }
            setErrorText(texts.errorMailValidate);
            return _context.abrupt("return");
          case 7:
            setErrorText('');
            setRequestStatus('pending');
            _context.next = 11;
            return subscribeMailingList({
              email: value,
              url: subscribeEmailURL,
              onSuccess: function onSuccess() {
                sendYmOnSubscribeSuccess();
                setValue('');
                setRequestStatus('success');
              },
              onError: function onError(error) {
                setErrorText(error || texts.errorText);
                setRequestStatus('error');
              }
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [subscribeEmailURL, value, texts]);
  var changeVisibleModal = useCallback(function (e) {
    e.preventDefault();
    setModalIsOpen(function (visible) {
      return !visible;
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('input__heading')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey95",
    size: "size5-m"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: cn('input__description')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s"
  }, texts.description)), requestStatus !== 'success' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    className: cn('input__actions', {
      'input__actions--vertical': isVertical
    }),
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('input__wrapper-input')
  }, /*#__PURE__*/React.createElement(Input, {
    errorMessage: errorText,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    placeholder: texts.inputPlaceholder,
    value: value
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('input__button', {
      'input__button--vertical': isVertical
    })
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !checked,
    fullWidth: true,
    isLoading: requestStatus === 'pending',
    size: "m",
    type: "submit",
    variant: "secondary"
  }, texts.button))), /*#__PURE__*/React.createElement("div", {
    className: cn('checkbox', {
      'checkbox--vertical': isVertical
    })
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    name: "personalData",
    onChange: function onChange(e) {
      return setChecked(e.currentTarget.checked);
    },
    rightSideNode: /*#__PURE__*/React.createElement("span", {
      className: cn('checkbox__info')
    }, /*#__PURE__*/React.createElement(Text, {
      color: "grey50",
      size: "size7-r"
    }, texts.personalDataText), /*#__PURE__*/React.createElement("a", {
      className: cn('checkbox__link'),
      href: "/",
      onClick: changeVisibleModal
    }, texts.personalDataButton)),
    size: "small"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: cn('success')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('success__title')
  }, /*#__PURE__*/React.createElement(MailIcon, {
    size: "s"
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('success__text')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-m"
  }, texts.successEmail))), /*#__PURE__*/React.createElement("div", {
    className: cn('success__tnx')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size5-r-s"
  }, texts.successEmailTnx))), consentText && /*#__PURE__*/React.createElement(Modal, {
    isOpen: modalIsOpen,
    onClose: function onClose() {
      return setModalIsOpen(false);
    },
    size: "l"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-l"
  }, consentText)));
});